import * as Sentry from "@sentry/react";

export const initSentry = () => {
  // Only initialize Sentry if DSN is provided
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.log('Sentry DSN not configured, error tracking disabled');
    return;
  }

  Sentry.init({
    dsn: "https://0c4b270f78c2333bf937b9f60cf81261@o32784.ingest.us.sentry.io/4510028593102848",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0, // 10% in production, 100% in dev

    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Ignore certain errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      // Random plugins/extensions
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      // Facebook flakiness
      'fb_xd_fragment',
      // Network errors
      'NetworkError',
      'Network request failed',
      // Canceled requests
      'AbortError',
      'canceled',
    ],

    // Release tracking
    release: import.meta.env.VITE_SENTRY_RELEASE || 'unknown',

    // Before send hook to filter/modify events
    beforeSend(event, hint) {
      // Filter out errors from browser extensions
      if (event.exception) {
        const error = hint.originalException;
        if (error && error.message && error.message.match(/chrome-extension:\/\//)) {
          return null;
        }
      }
      return event;
    },
  });
};

// Export Sentry for manual error capturing if needed
export { Sentry };
